export const CHECKOUT_URL = 'https://automotive-technology-instructor-ready.impultienda.ar/checkout'

export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/p54UHSfBworvsyKkwLkhJR/Diseno_sin_titulo_(67).png'

export interface IncludedItem {
  label: string
  kind: 'included' | 'bonus'
}

export const packageIncludes: IncludedItem[] = [
  { kind: 'included', label: 'Volume 1 — Automotive Foundations, Workshop Safety & Service Procedures' },
  { kind: 'included', label: 'Volume 2 — Engine Systems, Performance & Maintenance' },
  { kind: 'included', label: 'Volume 3 — Brakes, Steering, Suspension & Chassis' },
  { kind: 'included', label: 'Volume 4 — Automotive Electrical & Electronic Systems' },
  { kind: 'included', label: 'Volume 5 — Transmissions, Drivetrain & Power Delivery' },
  { kind: 'included', label: 'Volume 6 — Diagnostics, Climate Control & Advanced Vehicle Technology' },
  { kind: 'included', label: '150 Ready-to-Teach Automotive Technology Lessons' },
  { kind: 'bonus', label: 'Automotive Troubleshooting Logic Handbook' },
  { kind: 'bonus', label: 'Automotive Common Faults & Symptoms Handbook' },
  { kind: 'bonus', label: 'Automotive Systems Quick Reference Handbook' },
  { kind: 'bonus', label: 'Automotive Instructor Assessment & Question Bank' },
  { kind: 'bonus', label: 'Automotive Teaching & Explanation Handbook' },
  { kind: 'included', label: '100% Visual Core Teaching Material' },
  { kind: 'included', label: 'Immediate Digital Access' },
  { kind: 'included', label: 'PDF Format' },
]

export const finalIncludedItems: IncludedItem[] = [
  { kind: 'included', label: '6 Complete Volumes' },
  { kind: 'included', label: '150 Ready-to-Teach Automotive Technology Lessons' },
  { kind: 'included', label: 'Automotive Foundations & Workshop Procedures' },
  { kind: 'included', label: 'Engine Systems & Performance' },
  { kind: 'included', label: 'Brakes, Steering, Suspension & Chassis' },
  { kind: 'included', label: 'Automotive Electrical & Electronic Systems' },
  { kind: 'included', label: 'Transmissions & Drivetrain' },
  { kind: 'included', label: 'Diagnostics, HVAC & Advanced Vehicle Technology' },
  { kind: 'included', label: '100% Visual Core Teaching Material' },
  { kind: 'included', label: 'System Diagrams' },
  { kind: 'included', label: 'Component Breakdowns' },
  { kind: 'included', label: 'Workshop Procedures' },
  { kind: 'included', label: 'Diagnostic Workflows' },
  { kind: 'included', label: 'Correct-vs-Incorrect Comparisons' },
  { kind: 'included', label: 'Ready-to-Use Lesson Structures' },
  { kind: 'included', label: 'Instructor Assessment Tools' },
  { kind: 'bonus', label: '5 Professional Bonus Guides' },
  { kind: 'included', label: 'Immediate Digital Access' },
  { kind: 'included', label: 'PDF Format' },
]
